import createValues from './createValues';
import plain from './structure/plain';
export default createValues(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/values.js
// module id = dyLF
// module chunks = 1